import { errorHandler } from "vue-app-utils-web";

export default function setupErrorHandling (app, store) {
  if (import.meta.env.VITE_APP_ENABLE_ANALYTICS === "false") return;
  errorHandler(app, store);
}